import { render } from "./UploadForm.vue?vue&type=template&id=3d82130e&scoped=true"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"

import "./UploadForm.vue?vue&type=style&index=0&id=3d82130e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d82130e"]])

export default __exports__